<template>
    <AccountLayout :loading="0" :isError=true>
        <div>
            <v-container id="login">
                <v-row id="login-box" class="d-flex justify-center">
                    <v-col class="pl-0 pr-0" cols="12" sm="auto" md="auto" style="display:flex; z-index: 1; justify-center">
                        <div id="half-border">
                            <v-img :src="require('../../assets/Group 92911.svg')" contain width="459" height="462" style="
                                    position: absolute;
                                    z-index: 1;
                                    margin-top: 2rem;
                                    margin-left: -13rem;
                                " />
                        </div>
                        <v-card width="540" min-height="544px" style="border-radius: 0px 30px 30px 0px" elevation="0">
                            <v-card-text class="px-0 py-0">
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <v-row class="mx-md-12 mx-3">
                                        <v-col cols="12" sm="12" md="12" class="text-center pb-2">
                                            <div class="prompt-title-500" style="
                                                    color: #255d98;
                                                    font-weight: 400;
                                                    margin-top:50px;
                                                ">
                                                {{
                                                    $t(
                                                        "message.loginPage.register"
                                                    )
                                                }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-2">
                                            <div class="pa-0 form-label">
                                                {{
                                                    $t(
                                                        "message.loginPage.email"
                                                    )
                                                }}
                                                <strong>*</strong>
                                            </div>
                                            <v-text-field class="py-0" dense outlined v-model="email" :rules="emailRules"
                                                v-bind:placeholder="$t(
                                                    'message.loginPage.fillEmail'
                                                )
                                                    " type="email" required>
                                                <template #message="{ message }">
                                                    {{ $t(message) }}
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                            <div class="pa-0 form-label">
                                                {{
                                                    $t(
                                                        "message.loginPage.password"
                                                    )
                                                }}
                                                <strong>*</strong>
                                            </div>
                                            <v-text-field class="py-0" dense outlined v-model="password" :append-icon="showPass
                                                ? 'mdi-eye'
                                                : 'mdi-eye-off'
                                                " :rules="passwordRules" :type="showPass
        ? 'text'
        : 'password'
        " v-bind:placeholder="$t(
        'message.loginPage.passwordPlaceholder'
    )
        " @click:append="
        showPass = !showPass
        " required>
                                                <template #message="{ message }">
                                                    {{ $t(message) }}
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                            <div class="pa-0 form-label">
                                                {{
                                                    $t(
                                                        "message.loginPage.confirmPassword"
                                                    )
                                                }}
                                                <strong>*</strong>
                                            </div>
                                            <v-text-field class="py-0" dense outlined v-model="confirmPassword"
                                                :append-icon="showConfirmPass
                                                    ? 'mdi-eye'
                                                    : 'mdi-eye-off'
                                                    " :rules="[
        (v) =>
            (!!v && v) ===
            this.password ||
            'message.loginPage.invalidPassword',
    ]" :type="showConfirmPass
    ? 'text'
    : 'password'
    " v-bind:placeholder="$t(
        'message.loginPage.confirmPassword'
    )
        " @click:append="
        showConfirmPass =
        !showConfirmPass
        " required>
                                                <template #message="{ message }">
                                                    {{ $t(message) }}
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                            <v-row class="d-flex align-center">
                                                <v-col cols="1" sm="1" md="1" class="
                                                        mt-xs-n5 mt-md-0 mt-sm-0 py-0
                                                    " id="checkbox-register-page">
                                                    <v-checkbox v-model="checkbox" :rules="[
                                                        (v) => !!v || '',
                                                    ]" required></v-checkbox>
                                                </v-col>
                                                <v-col cols="11" sm="11" md="11" class="
                                                        px-md-0 px-sm-0
                                                        pr-xs-0
                                                    ">
                                                    <div class="prompt-16 ml-2" style="
                                                            font-weight: 400;
                                                            color: #9d9b9a;
                                                            text-align: start;
                                                        ">
                                                        {{
                                                            $t(
                                                                "message.loginPage.accept"
                                                            )
                                                        }}
                                                        <!-- <a class="
                                                                prompt-underline
                                                                text-decoration-underline
                                                            " href="/account/condition" target="_blank">{{
                                                                $t(
                                                                    "message.loginPage.terms"
                                                                )
                                                            }}</a>
                                                        {{
                                                            $t(
                                                                "message.loginPage.and"
                                                            )
                                                        }} -->
                                                        <br />
                                                        <a class="
                                                                prompt-underline
                                                                text-decoration-underline
                                                            " href="/account/policy" target="_blank">{{
                                                                $t(
                                                                    "message.loginPage.privacyPolicy"
                                                                )
                                                            }}</a>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="px-0 d-flex justify-center"
                                            style="padding-top: 12px;">
                                            <v-btn id="register-button" class="prompt-24" :disabled="!valid" :color="checkFill
                                                ? '#ff9800'
                                                : '#AFADB1'
                                                " @click="validate" rounded height="40" width="300" style="
                                                    font-weight: 400;
                                                    font-size: 18px;
                                                    line-height: 24px;
                                                    letter-spacing: 0.05rem;
                                                    color: #ffffff;
                                                ">
                                                {{
                                                    $t(
                                                        "message.loginPage.register"
                                                    )
                                                }}
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="
                                                py-0
                                                mt-3
                                            " style="margin-bottom:30px;">
                                            <div class="d-flex justify-center">
                                                <div class="prompt-caption mr-2">
                                                    {{
                                                        $t(
                                                            "message.loginPage.alreadyAccount"
                                                        )
                                                    }}
                                                </div>
                                                <a class="
                                                    prompt-underline
                                                    text-decoration-underline
                                                " href="/login" style="color: #ff9800">{{
                                                    $t(
                                                        "message.loginPage.login"
                                                    )
                                                }}</a>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div id="orange-tab"></div>
        </div>
    </AccountLayout>
</template>

<script>
import AccountLayout from "@/components/common/AccountLayout.vue";
import router from "@/router";
import * as services from "@/services";

export default {
    name: "RegisterComp",
    components: { AccountLayout },
    data: () => ({
        valid: true,
        form_id: "",
        password: "",
        passwordRules: [
            (v) => !!v || "message.loginPage.leastLetters",
            (v) => v.length > 8 || "message.loginPage.leastLetters",
            (v) => /[a-zA-Z]/.test(v) && /\d/.test(v) || "message.loginPage.leastLetters",
        ],
        confirmPassword: "",
        showPass: false,
        showConfirmPass: false,

        email: "",
        emailRules: [
            (v) => !!v || "message.loginPage.fillEmail",
            (v) => /.+@.+\..+/.test(v) || "message.loginPage.incorrectEmail",
        ],
        checkbox: false,
        loading: 0,
        isError: true
    }),
    methods: {
        validate() {
            const valid = this.$refs.form.validate();
            if (valid) {
                const body = {
                    student_email: this.email,
                    student_password: this.password,
                    form_id: this.form_id,
                };
                registerAccount(body);
            }
        },
        async getRegisterFormConfigFromLink() {
            try {
                this.loading++;
                const link = localStorage.getItem("registerLink");
                const { data } = await services.getRegisterFormIDFromLink({
                    link: link,
                });

                this.form_id = data.data.register_form_config.id;
            } catch (err) {
                this.loading--;
                window.location.href = "/error";
                console.log(err);
            }
            finally {
                this.loading--;
            }
        },
        async checkRegisterFormTimeOut() {
            let isError = false
            try {
                this.loading++;
                const { data } = await services.getRegisterFormIDFromLink({
                    link: localStorage.getItem("registerLink"),
                });
                if (data.data.timeout) {
                    router.push("/login");
                }
                else if (data.status.code === 404 || data.status.code === 405) {
                    isError = true
                }
                else {
                    this.form_id = data.data.register_form_config.id;
                }
            } catch (err) {
                isError = true
                console.log(err);
            }
            finally {
                this.loading--;
                if (isError) {
                    window.location.href = "/error";
                }
            }
        },
    },
    created() {
        localStorage.removeItem("email");
        this.checkRegisterFormTimeOut();
    },
    computed: {
        checkFill() {
            const validate = this.$refs.form;
            const checkNull =
                this.email != "" &&
                this.password != "" &&
                this.confirmPassword != "" &&
                this.checkbox;
            return validate?.value && checkNull;
        },
    }
};

const registerAccount = async (body) => {
    try {
        const res = await services.createAccount(body);
        if (res.statusText == "Created") {
            router.push("/login");
        }
    } catch (error) {
        console.log(error);
    }
};
</script>
